import React, { forwardRef } from 'react';
import { CFormLabel } from '@coreui/react';

const Label = forwardRef(({ className, ...props }, ref) => (
  <CFormLabel
    ref={ref}
    className={`text-sm font-medium ${className || ''}`}
    {...props}
  />
));

Label.displayName = 'Label';

export { Label }; 